export const arcHistoryOrderPath = (order: any) => {
  if (!order) return [];

  // Check if order has waypoints array
  if (order.waypoints && Array.isArray(order.waypoints)) {
    return order.waypoints
      .filter(({ latitude, longitude }: any) => latitude && longitude)
      .map(({ latitude, longitude }: any) => ({ lat: latitude, lng: longitude }));
  }

  // If no waypoints, create a simple path from drone to delivery location
  if (order.drone && order.deliveryLocation) {
    const droneLat = Number(order.drone.latitude);
    const droneLng = Number(order.drone.longitude);
    const deliveryLat = Number(order.deliveryLocation.latitude);
    const deliveryLng = Number(order.deliveryLocation.longitude);

    if (!isNaN(droneLat) && !isNaN(droneLng) && !isNaN(deliveryLat) && !isNaN(deliveryLng)) {
      return [
        { lat: droneLat, lng: droneLng },
        { lat: deliveryLat, lng: deliveryLng }
      ];
    }
  }

  return [];
};
